import $ from 'jquery';

export default class Http {
  static get(url: string): Promise {
    return Http._ajax({ url, method: 'GET' });
  }

  static post(url: string, data: Object): Promise {
    return Http._ajax({ url, data, method: 'POST' });
  }

  static _ajax(config: Object): Promise {
    return new Promise((resolve, reject) => {
      $.ajax({
        ...config,
        contentType: false,
        dataType: 'json',
        crossDomain: true,
        success: (data) => resolve(data),
        error: (err) => reject(err)
      });
    });
  }
}
